<template>
    <div ref="wrapper" class="background-image-wrapper" />
</template>

<script>
import frameTimer from '@kids/lib/service/frameTimer';

export default {
    name: 'BackgroundImage',
    props: {
        imageSrc: {
            type: String,
            default: ''
        }
    },
    watch: {
        imageSrc(src)
        {
            this._loader.loaded.then(() => this.replaceImage(src));
        }
    },
    methods: {
        replaceImage(newSrc)
        {
            const previousImageElement = this._imageElement;
            if (newSrc === '')
            {
                if (previousImageElement)
                {
                    previousImageElement.classList.remove('active');
                    previousImageElement.addEventListener(
                        'transitionend',
                        (evt) =>
                        {
                            evt.stopPropagation();
                            previousImageElement.remove();
                        }
                    );
                    this._imageElement = null;
                }
                return;
            }
            const newImageElement = this._loader.get(newSrc).cloneNode(true);
            newImageElement.classList.add('image');
            this.$refs.wrapper.appendChild(newImageElement);
            frameTimer.after(1, () => newImageElement.classList.add('active'));

            if (previousImageElement)
            {
                newImageElement.addEventListener(
                    'transitionend',
                    (evt) =>
                    {
                        evt.stopPropagation();
                        previousImageElement.remove();
                    }
                );
            }

            this._imageElement = newImageElement;
        },
        setLoader(loader)
        {
            this._loader = loader;
        }
    }
};
</script>

<style lang="scss" src="./BackgroundImage.scss" />

